import { createI18n, useI18n } from 'vue-i18n'
import type { App } from 'vue'
import { LOCALE, localeSetting } from '@/settings/localeSettings'
import { AcceptLanguageEnum } from '@/enums/httpEnum'
const isWebApp = import.meta.env.MODE == 'web'

const { fallback, availableLocales } = localeSetting

export const createI18nOptions = async (locale: string) => {
  const zhLocal = await import('./lang/zh_CN')
  const enLocal = await import(`./lang/en`)
  const nlLocal = await import(`./lang/nl`)
  const deLocal = await import(`./lang/de`)
  const esLocal = await import(`./lang/es`)
  const frLocal = await import(`./lang/fr`)
  const itLocal = await import(`./lang/it`)
  const zhHkLocal = await import(`./lang/zh_HK`)
  const zhMessage = zhLocal.default?.message ?? {}
  const enMessage = enLocal.default?.message ?? {}
  const nlMessage = nlLocal.default?.message ?? {}
  const deMessage = deLocal.default?.message ?? {}
  const esMessage = esLocal.default?.message ?? {}
  const frMessage = frLocal.default?.message ?? {}
  const itMessage = itLocal.default?.message ?? {}
  const zhHkMessage = zhHkLocal.default?.message ?? {}

  return {
    legacy: false,
    locale,
    fallbackLocale: fallback,
    messages: {
      zh_CN: zhMessage,
      en: enMessage,
      nl: nlMessage,
      de: deMessage,
      es: esMessage,
      fr: frMessage,
      it: itMessage,
      zh_HK: zhHkMessage
    },
    availableLocales: availableLocales,
    sync: true, //If you don’t want to inherit locale from global scope, you need to set sync of i18n component option to false.
    silentTranslationWarn: true, // true - warning off
    missingWarn: false,
    silentFallbackWarn: true
  }
}

export let i18n: ReturnType<typeof createI18n>

export const setupI18n = async (app: App) => {
  const options = await createI18nOptions(getGlobalLocale())
  i18n = createI18n(options)
  app.use(i18n)
}

export const getGlobalLocale = () => {
  let locale = localStorage.getItem('locale')
  let lang:string = LOCALE.EN_US
  if(locale == LOCALE.EN_US || locale == LOCALE.ZH_CN || locale == LOCALE.ZH_HK){
    lang = locale
  }else{
    localStorage.setItem('locale', lang)
  }
  if(!isWebApp){
    localStorage.setItem('languege', lang)
  }
  return lang
}

export const getGlobalHeaderLocale = () => {
  return getGlobalLocale()
}

export const setGlobalLocale = (locale: string) => {
  console.log("=====locale:",locale)
  if(!isWebApp){
    localStorage.setItem('languege', locale)
  }
  localStorage.setItem('locale', locale)
  i18n.global.locale = locale
}
